module.exports = __webpack_public_path__ + "img/DSC_0085.368cf85a.jpg";